<style lang="less" scoped>
/* title-contain */
.unhr-contain {
  .title-contain {
    border-left: 1px solid rgba(0,0,0,.12); 
  }
    .list-contain {
    /deep/.v-list-item__title {
       text-overflow:inherit;
       white-space: normal;
    }
  }
}
.stat-info-child-un {
  box-shadow: none!important;
  border-radius: 0;
   // border-left: 1px solid rgba(0,0,0,.12);
  /deep/.v-list-item--two-line {
    min-height: 0 !important;
  }
  /deep/.v-card__text {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  /deep/ .col-3 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
<template>
  <div class="unhr-contain">
    <v-list class="list-contain">
      <v-row>
        <v-col cols="5">
          <v-row>
            <v-col 
              cols="6"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ detail.team_name }}</v-list-item-title>
                  <v-list-item-subtitle>执行部门</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <!--  <v-col 
              cols="6"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ detail.title_name }}</v-list-item-title>
                  <v-list-item-subtitle>科目名称</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col> -->
            <v-col 
              cols="12"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ detail.remark }}</v-list-item-title>
                  <v-list-item-subtitle>备注</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col 
              cols="12"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <FileList :bfiles="detail.bfiles" />
                    <span v-if="!detail||!detail.bfiles">-</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>附件</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="7">
          <div class="title-contain">
            <v-card class="stat-info-child-un">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>
                    申请科目金额
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <DaynamicTable 
                      :table-data="detail.items"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-list>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import DaynamicTable from './DaynamicTable'
  import FileList from './FileList'
  export default {
    components: {
      FileList,
      DaynamicTable
    },
    props: {
      detail: {
        type: Object
      }
    },
    computed: {
      ...mapGetters('async', {
        customer_types_hash: 'customer_types_hash',
      }),
    }
  }
</script>
